export const signupConstants = {
  SIGNUP_NEXT_CLICK: "SIGNUP_NEXT_CLICK",
  SIGNUP_NEXT_CLEAR: "SIGNUP_NEXT_CLEAR",
  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",
};
